import { render, staticRenderFns } from "./SummerSale.vue?vue&type=template&id=16b9d418&scoped=true&"
import script from "./SummerSale.vue?vue&type=script&lang=js&"
export * from "./SummerSale.vue?vue&type=script&lang=js&"
import style0 from "./SummerSale.vue?vue&type=style&index=0&id=16b9d418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9d418",
  null
  
)

export default component.exports